import {
  lnrChampionApi,
  TLRChampionCreatePayload,
  TLRChampionUpdatePayload,
} from 'onboarding/api/lnrChampionApi'
import { TLNRChampionServer } from 'onboarding/components/widgets/public/forms/lnr/models'

class LnrChampionService {
  public async fetchOneByRequestId(requestId: number): Promise<TLNRChampionServer> {
    return lnrChampionApi.fetchOneByRequestId(requestId)
  }

  public async createOne(payload: TLRChampionCreatePayload): Promise<TLNRChampionServer> {
    return lnrChampionApi.createOne(payload)
  }

  public async updateOne(
    id: number,
    payload: TLRChampionUpdatePayload
  ): Promise<TLNRChampionServer> {
    return lnrChampionApi.updateOne(id, payload)
  }
}

export const lnrChampionService = new LnrChampionService()
